import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const settings = { timestampsInSnapshots: true };

const config = {
    //   apiKey: "YOUR_API_KEY",
    //   authDomain: "YOUR_AUTH_DOMAIN",
    //   databaseURL: "YOUR_DATABASE_URL",
    //   projectId: "YOUR_PROJECT_ID",
    //   storageBucket: "YOUR_STORAGE_BUCKET",
    //   messagingSenderId: "YOUR_MESSAGING_ID"
    apiKey: "AIzaSyA1BaeGgUIHg3V51iPBqisuA1unJKpGfhk",
    authDomain: "promocodes-f976f.firebaseapp.com",
    databaseURL: "https://promocodes-f976f.firebaseio.com",
    projectId: "promocodes-f976f",
    storageBucket: "promocodes-f976f.appspot.com",
    messagingSenderId: "922013515724",
    appId: "1:922013515724:web:d978bbf7313fa7d3d8a769",
    measurementId: "G-B88DF537GL"
};
firebase.initializeApp(config);
firebase.firestore().settings(settings);
export default firebase;